// values are translation codes


export const ERC20_TRANSACTION_TYPE = {
    TRANSFER: 'transfer',
    MINT: 'mint',
    BURN: 'burn',
    APPROVAL: 'approval',
    OTHER: 'other',
}

export const ERC721_TRANSACTION_TYPE = {
    TRANSFER: 'transfer',
    MINT: 'mint',
    BURN: 'burn',
    APPROVAL: 'approval',
    APPROVAL_FOR_ALL: 'approval_for_all',
    OTHER: 'other',
}

export const ERC1155_TRANSACTION_TYPE = {
    TRANSFER: 'transfer',
    MINT: 'mint',
    BURN: 'burn',
    APPROVAL: 'approval',
    APPROVAL_FOR_ALL: 'approval_for_all',
    OTHER: 'other',
}
